import { minimalInputTheme } from '@/app/theme';
import { yearFolderOptions } from '@/utils/constants';
import { Autocomplete, MenuItem, Select, TextField } from '@mui/material';
import React from 'react';

export const YearFolderSelect = ({
	name,
	value,
	disabled,
	onChange,
	minimal = false,
	error = false,
}) => {

	return (
		<Autocomplete
			id={name}
			name={name}
			fullWidth
			disabled={disabled}
			isOptionEqualToValue={(option, val) => option === val}
			getOptionLabel={(template) => template?.name ?? ''}
			options={yearFolderOptions}
			value={value}
			inputValue={value ?? ''}
			filterOptions={(options) => options}
			disableClearable
			onChange={(_, option) => onChange(option)}
			renderOption={(props, option) => {
				return (
					<li {...props} style={{ width: '100%' }} key={`folder-selection-${option}`}>
						{option}
					</li>
				);
			}}
			renderInput={(params) => (
				<TextField
					{...params}
					variant={minimal ? 'standard' : 'outlined'}
					error={error}
					onKeyDown={(e) => {
						e.preventDefault();
					}}
					slotProps={{
						input: {
							...params.InputProps,
							readOnly: true,

							style: {
								caretColor: 'transparent',
								cursor: 'pointer',
								...(minimal && {
									...(disabled && { backgroundColor: 'transparent' }),
								}),
							},
						},
					}}
					sx={(theme) => ({
						...(minimal && {
							...minimalInputTheme,
							'& .Mui-disabled': {
								backgroundColor: 'transparent',
							},
						}),
						'& .MuiInput-input': {
							color: theme.palette.primary.main,
						},
						cursor: 'pointer',
					})}
				/>
			)}
			sx={{
				cursor: 'pointer',
				'& .MuiInputBase-root': {
					cursor: 'pointer',
				},
				'& input': {
					cursor: 'pointer',
				},
				...(minimal && {
					...minimalInputTheme,
					'& .Mui-disabled': {
						backgroundColor: 'transparent',
					},
					'& .MuiInputBase-root': {
						backgroundColor: 'transparent',
					},
				}),
			}}
		/>
	);
};
